/* src/app/layout/fat-top-bar-layout/fat-top-bar-layout.component.css */
body {
  font-family:
    Roboto,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Oxygen,
    Ubuntu,
    Cantarell,
    "Open Sans",
    "Helvetica Neue",
    sans-serif;
}
.top-band {
  height: 35px;
  font-family: "Roboto", sans-serif;
  color: var(--light-text);
  background-color: var(--custom-color);
}
.ghjkl {
  color: var(--light-text);
}
.navbar1 {
  padding-left: 20px;
}
@media screen and (max-width: 600px) {
  .navbar1 {
    padding-left: 0px;
  }
}
::ng-deep .mat-form-field-infix {
  font-size: 14px;
  margin-left: 20px;
}
::ng-deep .custom .mat-form-field-underline {
  visibility: hidden !important;
}
::ng-deep .custom .mat-select-value {
  color: rgba(255, 255, 255, 0.6);
}
::ng-deep .custom .mat-select-arrow {
  color: rgba(255, 255, 255, 0.6);
}
.main-title {
  font-weight: 300;
  padding-left: 50px;
  padding-top: 10px;
  font-size: 15px;
  cursor: pointer;
}
.main-text {
  font-weight: 300;
  padding-top: 5px;
  padding-left: 23px;
  margin-top: 10px;
  font-size: 12pt;
  display: inline-block;
  cursor: pointer;
}
.tab-container {
  background-color: var(--custom-color);
  color: var(--light-text);
}
::ng-deep .navbar1 .mat-ink-bar {
  background-color: var(--primary-color) !important;
  height: 4px !important;
  margin-right: 10px;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
::ng-deep .mat-mdc-tab-header {
  border: 0 !important;
  padding-left: 0px;
}
.spacer {
  background: var(--light-text);
  height: 2px;
}
::ng-deep .mat-mdc-tab-nav-bar {
  background-color: var(--custom-color);
  padding: 0;
  border: 0px;
}
::ng-deep .mat-mdc-tab-link {
  color: var(--light-text);
}
::ng-deep .mat-mdc-tab-link:hover {
  color: var(--light-text);
  opacity: 1;
  text-decoration: none;
}
.nositesfiller {
  height: 35px;
}
/*# sourceMappingURL=fat-top-bar-layout.component.css.map */
